import React from "react";

const loadBookingPages = {
  bookingDetails: () => import("../../pages/booking/Booking-details/index.jsx"),
  paymentDetails: () => import("../../pages/booking/payment-options/index.jsx"),
  paymentProcessing: () => import("../../pages/booking/payment-processing/index.jsx"),
  paymentSuccess: () => import("../../pages/booking/payment-success/index.jsx"),
  PaymentFailure: () => import("../../pages/booking/payment-failure/index.jsx"),
  ConfirmBookingPartner: () => import("../../pages/booking/confirm-booking-partner/index.jsx"),
  PaymentInitializeMobile: () => import("../../pages/booking/mobile/initialize/index.jsx"),
  PaymentProcessingMobile: () => import("../../pages/booking/mobile/processing/index.jsx"),
  PaymentFailureMobile: () => import("../../pages/booking/mobile/failure/index.jsx"),
};

const bookingLazyPages = {
  bookingDetails: React.lazy(() => loadBookingPages.bookingDetails()),
  paymentDetails: React.lazy(() => loadBookingPages.paymentDetails()),
  paymentProcessing: React.lazy(() => loadBookingPages.paymentProcessing()),
  paymentSuccess: React.lazy(() => loadBookingPages.paymentSuccess()),
  PaymentFailure: React.lazy(() => loadBookingPages.PaymentFailure()),
  ConfirmBookingPartner: React.lazy(() => loadBookingPages.ConfirmBookingPartner()),
  PaymentInitializeMobile: React.lazy(() => loadBookingPages.PaymentInitializeMobile()),
  PaymentProcessingMobile: React.lazy(() => loadBookingPages.PaymentProcessingMobile()),
  PaymentFailureMobile: React.lazy(() => loadBookingPages.PaymentFailureMobile()),
};

export { loadBookingPages, bookingLazyPages };
